import { COLOR_HEX, COLOR_HEX_DARK, type PaletteColor } from "@trip/domain/palette";
import type { CSSProperties } from "react";

/**
 * A tag's colour, handed down to CSS.
 *
 * The same move the avatar makes with a person's colour, and for the same reasons. The hue goes
 * down as a custom property and every tint, border and ring is mixed from it in the stylesheet,
 * so a folder card, a badge on a recording and a row in the tag sheet cannot drift into three
 * slightly different versions of "green". Both themes go down together because CSS, not this
 * module, is what knows which one is on.
 *
 * `Untagged` has no colour, and neither has a tag whose colour has not arrived yet; both get
 * nothing back, and the plain uncoloured rendering of whatever they are in.
 */
export function tagInk(color: PaletteColor | null | undefined): CSSProperties | undefined {
  if (!color) return undefined;
  return {
    "--tag": COLOR_HEX[color],
    "--tag-dark": COLOR_HEX_DARK[color],
  } as CSSProperties;
}
